"use client";
import { LayoutProps } from "@/components/layout/layoutType";
import Underconstruction from "./underconstruction";
//import * as Setting from "@/components/page/setting";
import Signin from "../layout/user/signin";
import { Debug } from "@/util/debug";
import NotFound from "./notfound";
import { checkUserPageAuth } from "@/util/authutil";
import NotAuth from "./notauth";
import DefaultDataList from "./defaultList";
import { NextIntlClientProvider, useLocale } from "next-intl";
import { useMessages } from "@/app/hook/useMessages";
import { getMessageFallback, intlError } from "./main";
import AdminSignin from "../layout/user/adminsignin";
import BarcodeIntro from "./barcodeintro";
import CoffeeBeanIntro from "./coffeebeanintro";
import PrivacyPolicy from "./privacypolicy";
import Offline from "./offline";
import BrewingNoteIntro from "./brewingnoteintro";
// const DefaultDataList = dynamic(() => import("./defaultList"), { ssr: false });
const ssr = process.env.NEXT_PUBLIC_I18N === "ssr";

export default function Default({ params }: { params?: LayoutProps }) {
  const locale = useLocale();
  const messages = useMessages(locale);

  const page = params?.page;
  // Debug("default page : ", page);
  if (page) {
    params.pageAuth = checkUserPageAuth(params?.user?.usertype, params?.auth, page);
    const pageName = page.page ?? "";
    Debug(
      "page summary : " +
        pageName +
        "(" +
        page.name +
        "):" +
        page.link +
        "-" +
        (params.pageAuth.menu ? 1 : 0) +
        (params.pageAuth.listview ? 1 : 0) +
        (params.pageAuth.view ? 1 : 0) +
        (params.pageAuth.write ? 1 : 0) +
        (params.pageAuth.edit ? 1 : 0) +
        (params.pageAuth.remove ? 1 : 0),
      params.article_id,
    );
    //Debug("auth : L-" + page.listview + ", R-" + page.view + ", C-" + page.write + ", U-" + page.edit + ", D-" + page.remove);
    //Debug("CRUD : L-" + page.list + ", R-" + page.read + ", C-" + page.create + ", U-" + page.update + ", D-" + page.delete);
    //Debug(params.pageAuth);
    if (page.page === "Offline" || (params.offline && !params.page?.offline_use)) {
      return <Offline params={params} />;
    } else if (!params.pageAuth.listview) {
      if (params?.auth !== "loading") {
        Debug("권한없음");
        if (params != null && params.user == null && !params.pageAuth.listview) {
          return <Signin params={params} />;
        } else {
          if (page.auth) {
            const auth_keys = Object.keys(page.auth);
            const user_keys = params.auth ? Object.keys(params.auth) : [];
            const check_key = auth_keys.every(
              (item) => user_keys.includes(item) && params.auth instanceof Object && params.auth[item].select,
            );
            // Debug(params, page);
            if (check_key) {
              return <NotFound params={params} />;
            } else {
              return <NotAuth params={params} />;
            }
          } else {
            return <NotFound params={params} />;
          }
        }
        //return <Loading params={params} />;
      } else {
        //return <Loading params={params} />;
      }
    }

    switch (pageName) {
      case "Signin":
        return <Signin params={params} />;
      case "AdminSignin":
        return <AdminSignin params={params} />;
      case "BarcodeIntro":
        return <BarcodeIntro params={params} />;
      case "CoffeeBeanIntro":
        return <CoffeeBeanIntro params={params} />;
      case "BrewingNoteIntro":
        return <BrewingNoteIntro params={params} />;
      case "PrivacyPolicy":
        return <PrivacyPolicy params={params} />;
      case "Offline":
        return <Offline params={params} />;
      // case "Farm":
      //   return <Setting.Country params={params} />;
      default:
        // Debug("페이지 미지정 : " + pageName);
        // Debug(params);
        if (pageName !== "") {
          if (ssr) {
            if (messages) {
              return (
                <NextIntlClientProvider locale={locale} messages={messages} onError={intlError} getMessageFallback={getMessageFallback}>
                  <DefaultDataList params={params} />
                </NextIntlClientProvider>
              );
            } else {
              return "";
            }
          } else {
            return <DefaultDataList params={params} />;
          }
        } else if (params != null && params.user == null) {
          // return <Signin params={params} />;
          return <Underconstruction params={params} />;
        } else {
          return <Underconstruction params={params} />;
        }
    }
  } else {
    Debug("Page is null");
    //Debug(params);
    return <NotFound params={params} />;
  }
}
